export const DINEOUT_ORDER_URL = "DINEOUT_ORDER_URL";
export const DEFAULT_DINEOUT_ORDER_URL = "https://payments.swiggy.com/dineout/success";
export const CROUTON_WEBVIEW_IOS_VERSION = 534;

export enum DineoutCheckoutState {
    BILL_PAYMENT_CART = "BILL_PAYMENT_CART",
}
